/**
 * Плагин: при вложении/смене родителя синхронизируем иерархию viewElements и шлём updateNode.
 * node:embedded — только при вложении; при unembed X6 шлёт node:change:parent.
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const syncParentHierarchy = (cell, newParent, previousParent, options) => {
			if (modeler._applyingPatch || options?.silent) return;
			if (!cell || typeof cell.isNode !== 'function' || !cell.isNode()) return;

			const childId = cell.id;
			const newParentId =
				newParent && typeof newParent.isNode === 'function' && newParent.isNode()
					? (newParent.id ?? null)
					: null;
			const oldParentId =
				previousParent &&
				typeof previousParent.isNode === 'function' &&
				previousParent.isNode()
					? (previousParent.id ?? null)
					: null;
			if (newParentId === oldParentId) return;

			modeler._moveViewElementToParent(childId, newParentId);
			if (modeler._geometryGestureIds?.has(childId)) {
				return;
			}
			onPatch({
				patches: [
					{
						op: 'updateNode',
						viewIndex: VIEW_INDEX,
						identifier: childId,
						parentNodeId: newParentId,
						includeParent: true,
					},
				],
			});
		};

		const onNodeEmbedded = args => {
			const cell = args?.cell ?? args?.node;
			syncParentHierarchy(
				cell,
				args?.currentParent ?? cell?.getParent?.(),
				args?.previousParent,
				args?.options
			);
		};

		const onNodeChangeParent = args => {
			const cell = args?.cell ?? args?.node;
			syncParentHierarchy(cell, cell?.getParent?.(), args?.previousParent, args?.options);
		};

		graph.on('node:embedded', onNodeEmbedded);
		graph.on('node:change:parent', onNodeChangeParent);

		return () => {
			graph.off('node:embedded', onNodeEmbedded);
			graph.off('node:change:parent', onNodeChangeParent);
		};
	},
};
